"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
var id_1 = require("../utils/id");
var Context = (function () {
    function Context(container) {
        this.id = (0, id_1.id)();
        this.container = container;
    }
    Context.prototype.addPlan = function (plan) {
        this.plan = plan;
    };
    Context.prototype.setCurrentRequest = function (currentRequest) {
        this.currentRequest = currentRequest;
    };
    return Context;
}());
exports.Context = Context;
